import React from "react";
import { Button } from "antd";
import errorBoundary from "../../assets/images/error-boundary.svg";
import { useLocation } from "react-router";

interface ContentErrorUiInterface {}

const ContentErrorUi: React.FC<ContentErrorUiInterface> = () => {
  const location = useLocation();

  return (
    <div className="sideNav-error">
      <div className="sideNav-error_heading-wrapper">
        <img src={errorBoundary} alt="" width={150} />
        <span>Oops!</span>
        <p>Something Went Wrong</p>
        <Button
          type="primary"
          onClick={() => window.location.replace(location?.pathname)}
        >
          Refresh
        </Button>
      </div>
    </div>
  );
};

export default ContentErrorUi;
